import React from 'react';

const Dummy = () => <>dummy</>;

export const reactWidgetMap: Record<string, React.FCC<Record<string, any>>> = {
    LibraryEntriesDashboard: React.lazy(
        () => import(/* webpackChunkName: "LibraryContent"*/ 'src/LibraryContent/LibraryEntriesDashboard')
    ),
    LibrarySingleEntry: React.lazy(
        () => import(/* webpackChunkName: "LibrarySingleEntry"*/ 'src/LibrarySingleEntry/LibrarySingleEntry')
    ),
    LatestLibraryEntries: React.lazy(
        () => import(/* webpackChunkName: "LatestLibraryEntries"*/ 'src/LatestLibraryEntries/LatestLibraryEntries')
    ),
    FeedWidget: React.lazy(() => import(/* webpackChunkName: "Feed"*/ 'src/Feed/Feed')),
    MicrositeFeedWidget: React.lazy(() => import(/* webpackChunkName: "Feed"*/ 'src/Feed/Feed')),
    QuickLinksWidget: React.lazy(() => import(/* webpackChunkName: "QuickLinks"*/ 'src/QuickLinks/QuickLinks')),
    RibbonsBadges: React.lazy(() => import(/* webpackChunkName: "RibbonsBadges"*/ 'src/RibbonsBadges/RibbonsBadges')),
    ProfileSnippet: React.lazy(
        () => import(/* webpackChunkName: "ProfileSnippet"*/ 'src/ProfileSnippet/ProfileSnippet')
    ),
    BioBubbleLink: React.lazy(() => import(/* webpackChunkName: "BioBubbleLink"*/ 'src/BioBubble/BioBubbleLink')),
    BioBubbleLinkR: React.lazy(() => import(/* webpackChunkName: "BioBubbleLinkR"*/ 'src/BioBubble/BioBubbleLinkR')),
    CMSEditorContainer: React.lazy(() => import('hlContentDesigner/CMSEditorContainer')),
    CalendarContainer: React.lazy(() => import(/* webpackChunkName: "Calendar"*/ 'src/Calendar/Calendar')),
    PollTakingContainer: React.lazy(() => import(/* webpackChunkName: "Poll"*/ 'src/Poll/Poll')),
    AdminPollContainer: React.lazy(() => import('hlReactRootLegacy/AdminPollContainer')),
    RecentlyFollowedContent: React.lazy(
        () =>
            import(
                /* webpackChunkName: "RecentlyFollowedContent"*/ 'src/RecentlyFollowedContent/RecentlyFollowedContent'
            )
    ),
    WarningAlert: React.lazy(() => import(/* webpackChunkName: "WarningAlert"*/ 'src/Alert/WarningAlert')),
    MembershipSelection: React.lazy(
        () => import(/* webpackChunkName: "MembershipSelection"*/ 'src/Membership/MembershipSelection')
    ),
    MostActiveMembers: React.lazy(
        () => import(/* webpackChunkName: "MostActiveMembers"*/ 'src/MostActiveMembers/MostActiveMembers')
    ),
    MyMembershipSummary: React.lazy(
        () => import(/* webpackChunkName: "MyMembershipSummary"*/ 'src/Membership/MyMembershipSummary')
    ),
    MyMembershipFull: React.lazy(
        () => import(/* webpackChunkName: "MyMembershipFull"*/ 'src/Membership/MyMembershipFull')
    ),
    MembershipPaymentCancel: React.lazy(
        () => import(/* webpackChunkName: "MembershipPaymentCancel"*/ 'src/Membership/MembershipPaymentCancel')
    ),
    MembershipPaymentSuccess: React.lazy(
        () => import(/* webpackChunkName: "MembershipPaymentSuccess"*/ 'src/Membership/MembershipPaymentSuccess')
    ),
    MyCommunitiesQuickList: React.lazy(
        () =>
            import(/* webpackChunkName: "MyCommunitiesQuickList"*/ 'src/MyCommunitiesQuickList/MyCommunitiesQuickList')
    ),
    FeaturedCardGrid: React.lazy(
        () => import(/* webpackChunkName: "FeaturedCardGrid"*/ 'src/FeatureCard/FeaturedCardGrid')
    ),
    RecentBlogs: React.lazy(() => import(/* webpackChunkName: "RecentBlogs"*/ 'src/RecentBlogs/RecentBlogs')),
    RibbonDisplay: React.lazy(() => import(/* webpackChunkName: "RibbonDisplay"*/ 'src/RibbonsBadges/RibbonDisplay')),
    RibbonBadgeAssignment: React.lazy(
        () => import(/* webpackChunkName: "RibbonBadgeAssignment"*/ 'src/RibbonAssignment/RibbonBadgeAssignment')
    ),
    ThreadListWidget: React.lazy(
        () => import(/* webpackChunkName: "ThreadListWidget"*/ 'src/ThreadList/ThreadListWidget')
    ),
    WebsiteAlert: React.lazy(() => import(/* webpackChunkName: "WebsiteAlert"*/ 'src/WebsiteAlert/WebsiteAlert')),
    RtjNotificationDropDown: React.lazy(
        () =>
            import(
                /* webpackChunkName: "RtjNotificationDropDown"*/ 'src/PartialComponents/RtjNotificationDropDown/RtjNotificationDropDown'
            )
    ),
    CommunityEventsList: React.lazy(
        () => import(/* webpackChunkName: "CommunityEventsList"*/ 'src/CommunityEventsList/CommunityEventsList')
    ),
    TagGroupsList: React.lazy(() => import(/* webpackChunkName: "TagsDisplay"*/ 'src/ItemTags/TagGroupsList')),
    MobileFab: React.lazy(() => import(/* webpackChunkName: "MobileFab"*/ 'src/MobileFab/MobileFab')),
    AiSearchResult: React.lazy(() => import(/* webpackChunkName: "AiSearchResult"*/ 'src/AI/search/AiSearchResult')),
    EditorChat: React.lazy(() => import(/* webpackChunkName: "EditorChat"*/ 'src/AI/chat/EditorChat')),
    AiFab: React.lazy(() => import(/* webpackChunkName: "AiFab"*/ 'src/AI/fab/AiFab')),
    AiChat: React.lazy(() => import(/* webpackChunkName: "AiChat"*/ 'src/AI/chatWidget/AiChat')),
    CopyButton: React.lazy(() => import(/* webpackChunkName: "CopyButton"*/ 'src/CopyButton/CopyButton')),
    LanguagePreference: React.lazy(
        () => import(/* webpackChunkName: "LanguagePreference"*/ 'src/LangaugePreference/LanguagePreference')
    ),
    LanguageSwitcher: React.lazy(
        () => import(/* webpackChunkName: "LanguageSwitcher"*/ 'src/LanguageSwitcher/LanguageSwitcher')
    ),
    Dummy
};

export type WidgetName = keyof typeof reactWidgetMap;
